import React from 'react';
import { CheckboxProps } from 'antd/lib/checkbox';

import { Checkbox, Input, Text } from 'components';

import { StyledInputContainer, StyledOptionsContainer } from './styled';

export type EmailInputValueType = {
  email: string;
  sendEmail: boolean;
};

export type EmailInputProps = {
  value: EmailInputValueType;
  onChange: (value: EmailInputValueType) => void;
  disabled?: boolean;
  error?: string;
  dataCy?: string;
};

const EmailInput: React.FC<EmailInputProps> = ({
  value,
  onChange,
  disabled,
  error,
  dataCy,
}) => {
  const { email, sendEmail } = value;

  const handleOnEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updatedEmail = e.target.value;

    onChange({
      ...value,
      email: updatedEmail,
    });
  };

  const handleOnSendEmailChange: CheckboxProps['onChange'] = e => {
    const updatedSendEmail = e.target.checked;

    onChange({
      ...value,
      sendEmail: updatedSendEmail,
    });
  };

  return (
    <StyledInputContainer>
      <Input
        label="Email"
        value={email}
        onChange={handleOnEmailChange}
        disabled={disabled}
        position="after"
        error={error}
        data-cy={dataCy}
      />
      <StyledOptionsContainer
        data-cy={dataCy ? `${dataCy}-toggle-container` : undefined}
      >
        <Checkbox
          checked={sendEmail}
          onChange={handleOnSendEmailChange}
          data-cy={dataCy ? `${dataCy}-toggle-emails` : undefined}
        >
          <Text strong>SEND EMAILS</Text>
        </Checkbox>
      </StyledOptionsContainer>
    </StyledInputContainer>
  );
};

export default EmailInput;
